import React, { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AuthContext } from "../App";

export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  // Only keep the Home link visible
  const links = [
    { path: "/", label: "Home" },
    // { path: "/partners", label: "Lending Partners" },
    // { path: "/contact", label: "Contact" },
    // { path: "/privacy-policy", label: "Privacy Policy" },
    // { path: "/terms", label: "Terms & Conditions" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    setIsAuthenticated(false);
    navigate("/login");
  };

  return (
    <header className="bg-white border-b shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          {/* ✅ Fixed Logo Path */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/imgs/Duit_Logo_chain.png"
                alt="Duit Digital Logo"
                className="w-10 h-10"
              />
              <div>
                <h1 className="text-xl font-bold text-black">Duit Digital</h1>
                <p className="text-xs text-gray-500">Smart Loan Solutions</p>
              </div>
            </Link>
          </div>

          <div className="hidden md:flex md:items-center md:space-x-4">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "text-teal-600 bg-teal-50"
                    : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* ✅ Logout Button (Only visible when authenticated) */}
          {isAuthenticated && (
            <button
              onClick={handleLogout}
              className="hidden md:inline-block bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-colors"
            >
              Logout
            </button>
          )}

          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-teal-600 focus:outline-none"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-white border-t mt-2">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className="block px-4 py-2 text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              >
                {link.label}
              </Link>
            ))}
            {isAuthenticated && (
              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-red-600 hover:text-red-700 hover:bg-red-50"
              >
                Logout
              </button>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}

export default Navigation;
